"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Add a reward item to order in form of adjustment
 * @param event event of type AddRewardItemEvent
 * @param prevState previous order state
 */
function default_1(event, prevState = {}) {
    var _a, _b;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const rewardAdjustment = {
        id: event.rewardId,
        adjustmentUnit: domain_1.AdjustmentUnit[event.discountType],
        adjustmentType: domain_1.AdjustmentType.REWARD,
        allowOnPaymentType: false,
        name: event.rewardName,
        rewardType: event.rewardType,
        pointsRequired: event.pointsRequired,
        amount: -event.discountAmount,
        maximumAmount: event.maximumDiscountAmount,
        quantity: event.quantity,
        createdAt: event.timestamp,
    };
    if (event.productId) {
        if (event.itemQuantity) {
            // split the case for itemQuantity as it can be tricky
            const rewardedItems = (_a = order.orderItems) === null || _a === void 0 ? void 0 : _a.filter(item => {
                var _a;
                return (item.product.id === event.productId ||
                    ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.id) === event.productId) &&
                    !domain_1.EXCLUDED_ITEM_STATUSES.includes(item.status);
            });
            if (rewardedItems === null || rewardedItems === void 0 ? void 0 : rewardedItems.length) {
                let remainingQuantity = event.itemQuantity;
                for (const item of rewardedItems) {
                    const applyQuantity = remainingQuantity > item.quantity
                        ? item.quantity
                        : remainingQuantity;
                    item.adjustments = [
                        { ...rewardAdjustment, itemQuantity: applyQuantity },
                    ];
                    item.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(item);
                    remainingQuantity = remainingQuantity - applyQuantity;
                    // if theres remaining quantity, spill over to the next item. Otherwise, break
                    if (remainingQuantity <= 0)
                        break;
                }
            }
        }
        else {
            // item level discount
            const rewardedItems = (_b = order.orderItems) === null || _b === void 0 ? void 0 : _b.find(item => {
                var _a;
                return (item.product.id === event.productId ||
                    ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.id) === event.productId) &&
                    !domain_1.EXCLUDED_ITEM_STATUSES.includes(item.status);
            });
            if (rewardedItems) {
                // item found, apply adjustment to this item
                rewardedItems.adjustments = [rewardAdjustment];
                rewardedItems.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(rewardedItems);
            }
        }
    }
    else {
        // order level discount
        order.adjustments = order.adjustments || [];
        order.adjustments.push(rewardAdjustment);
    }
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=addRewardItem.js.map